import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks';
import { AgreementModal } from './TermsAndPrivacyConsent';
import { acceptTermsAndConditionsAsync, fetchUserAccountDetailsAsync } from 'src/redux/actions/accountActions';
import useAppToast from 'src/hooks/useAppToast';
import Loader from 'src/utils/Loader'

export const TermsAcceptanceGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData);
  const [isAccepting, setIsAccepting] = useState(false);
  const { errorToast } = useAppToast();

  const accountType = fetchedUserAccountData?.account_type;
  const isImpersonating = !!localStorage.getItem('loggedInAdminAccessToken');
  const userInfo = fetchedUserAccountData?.userAdditionalInfo;
  const hasAcceptedTerms = userInfo?.terms_accepted_at || userInfo?.terms_accepted_ip;

  // Only show modal for DIRECT and USER_STAFF account types
  // Skip: no data yet, superadmin, ADMIN_STAFF, impersonation, or already accepted
  const shouldSkip =
    !fetchedUserAccountData ||
    fetchedUserAccountData.is_superuser ||
    accountType === 'ADMIN_STAFF' ||
    isImpersonating ||
    hasAcceptedTerms ||
    (accountType !== 'DIRECT' && accountType !== 'USER_STAFF');

  if (shouldSkip) {
    return <>{children}</>;
  }

  const handleAccept = async () => {
    setIsAccepting(true);
    try {
      const response = await dispatch(acceptTermsAndConditionsAsync());
      if (response.payload?.success) {
         await dispatch(fetchUserAccountDetailsAsync());
      } else {
        errorToast(response.payload?.message || "Failed to accept terms. Please try again.");
      }
    } catch (error) {
       errorToast("An unexpected error occurred. Please try again.");
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <>
      {children}
      {createPortal(
        <div style={{ position: 'fixed', zIndex: 2147483647, top: 0, left: 0, width: '100vw', height: '100vh' }}>
            <style dangerouslySetInnerHTML={{ __html: `
            
            `}} />
            <div className="terms-acceptance-gate-modal">
                <AgreementModal
                    isAlreadyAgreed={false}
                    onClose={() => {}} // Do nothing, cannot be closed
                    onAgree={handleAccept}
                />
            </div>
             
             {isAccepting && (
                  <div style={{
                      position: 'fixed',
                      top: 0, left: 0, right: 0, bottom: 0,
                      background: 'rgba(255, 255, 255, 0.5)',
                      zIndex: 2147483648,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'wait'
                  }}>
                      <Loader variant="section" />
                  </div>
              )}
        </div>,
        document.body
      )}
    </>
  );
};
